// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popup_overlay__4y2IQ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.Popup_popup__iE4Zw {
  position: relative;
  background: linear-gradient(135deg, #5b2a85, #3b0a60);
  padding: 24px;
  border-radius: 16px;
  text-align: center;
  max-width: 300px;
  box-shadow: 0 0 20px rgba(140, 100, 255, 0.3);
  color: #fff;
}

.Popup_popup__iE4Zw p {
  margin-bottom: 20px;
  font-size: 16px;
}

.Popup_closeButton__6ouGl {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}

.Popup_closeButton__6ouGl:hover {
  color: #ccc;
}

.Popup_buttons__9mGIm {
  display: flex;
  justify-content: center;
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Popup/Popup.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.popup {\n  position: relative;\n  background: linear-gradient(135deg, #5b2a85, #3b0a60);\n  padding: 24px;\n  border-radius: 16px;\n  text-align: center;\n  max-width: 300px;\n  box-shadow: 0 0 20px rgba(140, 100, 255, 0.3);\n  color: #fff;\n}\n\n.popup p {\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.closeButton:hover {\n  color: #ccc;\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `Popup_overlay__4y2IQ`,
	"popup": `Popup_popup__iE4Zw`,
	"closeButton": `Popup_closeButton__6ouGl`,
	"buttons": `Popup_buttons__9mGIm`
};
export default ___CSS_LOADER_EXPORT___;
